// extracted by mini-css-extract-plugin
module.exports = {"label":"RuleProcessing_label__1svSd"};